import { store } from 'store/reducers'
import { intersection, uniq } from 'lodash'

export const getScheduleTypeInitialvalue = shifts => {
  const {
    resources: { nonFilterScheduleTypes, positionsById }
  } = store.getState()

  // For each shift find the scheduleType Options
  const scheduleTypes = shifts.map(shift => {
    // Get the departments for the position of the shift
    const shiftDepartments = positionsById[shift.positionId]?.departments || []

    // Find all the schedule Types corresponding to the position departments
    const scheduleTypesOptions = []
    for (let scheduleType of nonFilterScheduleTypes) {
      if (intersection(scheduleType.departments, shiftDepartments).length) scheduleTypesOptions.push(scheduleType)
    }
    // Find if there is one scheduleType in the scheduleTypeOptions corresponding to the start and end of each shift
    let shiftScheduleType = 'custom'
    for (let scheduleType of scheduleTypesOptions) {
      if (shift.start === scheduleType.startTime && shift.end === scheduleType.endTime) shiftScheduleType = scheduleType._id
    }
    return shiftScheduleType
  })

  // If there is only one shift, return the scheduleType
  if (shifts.length === 1) return scheduleTypes[0]

  // If there are multiple shifts
  // If they all have the same scheduleType return the scheduleTypeId
  if (uniq(scheduleTypes).length === 1) return scheduleTypes[0]

  // Check if they have at least one scheduleType in commun, otherwise return an empty string to hide the select
  if (!getScheduleTypesOptions(shifts)) return ''
  // Show the multiple values button if they have different scheduleTypes of start/end times
  return 'multipleValues'
}

export const getScheduleTypesOptions = shifts => {
  const {
    resources: { nonFilterScheduleTypes, positionsById }
  } = store.getState()
  const filteredScheduleTypes = []
  let shiftsDepartments = shifts.map(shift => positionsById[shift.positionId]?.departments || [])
  let commonDepartments = intersection(...shiftsDepartments)

  for (let scheduleType of nonFilterScheduleTypes) {
    if (!scheduleType?.departments?.length || intersection(scheduleType.departments, commonDepartments).length) filteredScheduleTypes.push(scheduleType)
  }
  return filteredScheduleTypes
}
